import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import HttpApis from "../../services/HttpApis";
import "./Unsubscribe.css";

// Landing page for the "Unsubscribe" link in marketing emails (new-release
// alerts). Deliberately does NOT call the API on mount — mail-client link
// scanners (Outlook Safe Links etc.) prefetch this page's GET, and if loading
// it unsubscribed people automatically, scanners would silently unsubscribe
// everyone before a human ever saw it. Only the button click mutates anything.
export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [status, setStatus] = useState(token ? "confirm" : "invalid");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const readError = (err) =>
    err?.response?.data?.message || "This unsubscribe link is no longer valid.";

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      const response = await HttpApis.unsubscribe({ token });
      setMessage(
        response?.data?.message ||
          "You've been unsubscribed from new-release emails."
      );
      setStatus("success");
    } catch (err) {
      setMessage(readError(err));
      setStatus("invalid");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="unsubscribe-container">
      <div className="unsubscribe-card">
        {status === "confirm" && (
          <>
            <div className="unsubscribe-icon unsubscribe-icon--confirm">✕</div>
            <h1>Unsubscribe from new&#8209;release emails?</h1>
            <p>
              You'll stop receiving "New on" content alerts. This won't affect
              your account or password-reset emails.
            </p>
            <button
              className="unsubscribe-btn"
              onClick={handleConfirm}
              disabled={submitting}
            >
              {submitting ? "Unsubscribing…" : "Confirm Unsubscribe"}
            </button>
          </>
        )}

        {status === "success" && (
          <>
            <div className="unsubscribe-icon unsubscribe-icon--success">
              &#10003;
            </div>
            <h1>You&rsquo;re unsubscribed</h1>
            <p>{message}</p>
          </>
        )}

        {status === "invalid" && (
          <>
            <div className="unsubscribe-icon unsubscribe-icon--invalid">!</div>
            <h1>Link expired or invalid</h1>
            <p>{message || "This unsubscribe link is no longer valid."}</p>
          </>
        )}
      </div>
    </div>
  );
}
